import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './componentes/Login'
import Viewer from './componentes/Viewer'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* "/" mostra o Login */}
        <Route path="/" element={<Login />} />
        {/* "/viewer" mostra seu componente */}
        <Route path="/viewer" element={<Viewer />} />
        {/* qualquer outra rota cai no Login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;